// Types
import { UserRole } from 'api/graphql-global-types';
// Helpers
import { getPersonName } from 'pages/Events/helpers';

const ROLE_LABELS: Partial<Record<UserRole, string>> = {
  [UserRole.Organization]: 'Organization',
  [UserRole.Athlete]: 'Athlete',
  [UserRole.ContentCreator]: 'Content creator',
};

type HostLabelSource = {
  storeDetails?: { storeName?: string | null } | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  role?: UserRole | null;
};

export const getHostLabel = (host: HostLabelSource): string =>
  [
    getPersonName(host, 'Unnamed store'),
    host.role ? ROLE_LABELS[host.role] : null,
    host.email,
  ]
    .filter(Boolean)
    .join(' · ');
